import services from './services.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';


export default {
    mixins: [services],
    data() {
        return {
            dialogVisible: false, //添加事项类型弹窗
            MatterTypeName: ''
        }
    },
    computed: {},
    methods: {
        getAddFormData() {
            return cloneDeep({

            });
        },
        dialogClose() {
            this.dialogVisible = false;
            this.MatterTypeName = ''
        },
        show(options) {
            let opts = $.extend({}, options);
            this.dialogVisible = true;
            this.MatterTypeName = ''
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/components/addMatterType/vm.js